import React from 'react';
import { Link } from 'react-router-dom';

const ServiceChamSocPage = () => {
    return (
        <main className="product-category" style={{ borderBottom: '1px solid #ececec', paddingBottom: 20 }}>
            {/* ════ MINIMAL BREADCRUMBS ════ */}
            <div className="py-4 mt-[50px]">
                <div className="container px-4 text-left">
                    <nav aria-label="breadcrumb">
                        <ol className="flex items-center gap-2 text-xs md:text-sm uppercase tracking-wider mb-0 p-0 list-none">
                            <li className="breadcrumb-item">
                                <Link to="/" className="hover:text-red-600 transition-colors no-underline text-slate-500">Trang chủ</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item">
                                <Link to="/dich-vu" className="hover:text-red-600 transition-colors no-underline text-slate-500">Dịch vụ</Link>
                            </li>
                            <span className="opacity-30">/</span>
                            <li className="breadcrumb-item active text-slate-900 font-bold" aria-current="page">
                                Chăm Sóc & Làm Đẹp
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container">
                <h1 className="heading-primary text-center" style={{ margin: '60px 0' }}>
                    <span>Chăm Sóc &amp; Làm Đẹp Ô Tô</span>
                </h1>
                <p className="text-center">
                    Khu vực giới thiệu các gói chăm sóc, làm đẹp xe (đánh bóng, phủ ceramic, dọn nội thất, rửa khoang
                    máy...) với bố cục tương tự các section trên homepage.
                </p>
            </div>
        </main>
    );
};

export default ServiceChamSocPage;




